import { LOCATION_CHANGE, replace, push } from 'connected-react-router'
import { SETUP_MFA_ENFORCED, SETTINGS } from '../constants/routes'
import { getShouldSetupMFA } from '../selectors/settings'

const removeTrailingSlash = str => {
  if (str.endsWith('/')) {
    return str.substr(0, str.length - 1)
  }
  return str
}

export default ({ getState }) => next => action => {
  if (action.type === LOCATION_CHANGE) {
    const state = getState()
    const shouldSetupMFA = getShouldSetupMFA(state)

    const { firstPage, key, pathname } = action.payload.location
    const route = removeTrailingSlash(pathname)
    const isInternalRedirect = !!key && !firstPage

    if (!isInternalRedirect && shouldSetupMFA) {
      if (key) {
        return next(replace(SETUP_MFA_ENFORCED))
      } else {
        return next(push(SETUP_MFA_ENFORCED))
      }
    }

    if (route === SETUP_MFA_ENFORCED && !shouldSetupMFA) {
      return next(push(SETTINGS))
    }
  }

  return next(action)
}
